import { render, staticRenderFns } from "./AdminRegistersRootView.vue?vue&type=template&id=8e4a7436"
import script from "./AdminRegistersRootView.vue?vue&type=script&lang=js"
export * from "./AdminRegistersRootView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports